/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `segment_leaderboard_entry` message.
 *
 * Unique Identification data for an individual segment leader within a segment file
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class SegmentLeaderboardEntryMesg : Mesg {
    public constructor() : super("SegmentLeaderboardEntry", Profile.MesgNum.SEGMENT_LEADERBOARD_ENTRY)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** name. Friendly name assigned to leader */
    public var name: String?
        get() = getFieldValue(NAME_FIELD_NUM) as? String
        set(value) = setFieldValue(NAME_FIELD_NUM, value)

    /** type. Leader classification */
    public var type: SegmentLeaderboardType?
        get() = (getFieldValue(TYPE_FIELD_NUM) as? UByte)?.let { SegmentLeaderboardType.fromValue(it) }
        set(value) = setFieldValue(TYPE_FIELD_NUM, value?.value)

    /** group_primary_key. Primary user ID of this leader */
    public var groupPrimaryKey: UInt?
        get() = getFieldValue(GROUP_PRIMARY_KEY_FIELD_NUM) as? UInt
        set(value) = setFieldValue(GROUP_PRIMARY_KEY_FIELD_NUM, value)

    /** activity_id. ID of the activity associated with this leader time */
    public var activityId: UInt?
        get() = getFieldValue(ACTIVITY_ID_FIELD_NUM) as? UInt
        set(value) = setFieldValue(ACTIVITY_ID_FIELD_NUM, value)

    /** segment_time, in s. Segment Time (includes pauses) */
    public var segmentTime: Double?
        get() = getFieldValue(SEGMENT_TIME_FIELD_NUM) as? Double
        set(value) = setFieldValue(SEGMENT_TIME_FIELD_NUM, value)

    /** activity_id_string. String version of the activity_id. 21 characters long, express in decimal */
    public var activityIdString: String?
        get() = getFieldValue(ACTIVITY_ID_STRING_FIELD_NUM) as? String
        set(value) = setFieldValue(ACTIVITY_ID_STRING_FIELD_NUM, value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val NAME_FIELD_NUM: UByte = 0u
        public const val TYPE_FIELD_NUM: UByte = 1u
        public const val GROUP_PRIMARY_KEY_FIELD_NUM: UByte = 2u
        public const val ACTIVITY_ID_FIELD_NUM: UByte = 3u
        public const val SEGMENT_TIME_FIELD_NUM: UByte = 4u
        public const val ACTIVITY_ID_STRING_FIELD_NUM: UByte = 5u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("Name", 0u, BaseType.STRING, 1.0, 0.0, "", false)
            fields[1] = Field("Type", 1u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[2] = Field("GroupPrimaryKey", 2u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[3] = Field("ActivityId", 3u, BaseType.UINT32, 1.0, 0.0, "", false)
            fields[4] = Field("SegmentTime", 4u, BaseType.UINT32, 1000.0, 0.0, "s", false)
            fields[5] = Field("ActivityIdString", 5u, BaseType.STRING, 1.0, 0.0, "", false)
            return fields
        }
    }
}
